/*
 * Home only: hides the header logo until the hero wordmark has scrolled
 * fully out of view, so the brand name isn't shown twice above the fold.
 *
 * This used to also reveal a mobile-only magnifier once the persistent
 * header search row scrolled under the fixed bar, but that row (and the
 * button that scrolled back up to focus it) was removed — the header's own
 * search icon and the mobile drawer's inline search cover that job now.
 *
 * The mechanism is a throttled scroll listener, NOT IntersectionObserver —
 * see the comment on update() below for why the obvious tool was rejected.
 */
(function () {
  function init() {
    var headerWrapper = document.querySelector('.header-wrapper');
    var header = document.querySelector('.header');
    if (!headerWrapper || !header) return;

    // Home only: the header logo and the giant hero wordmark
    // (hs-shed-text-hero.liquid, now the page's one <h1>) say the same
    // thing twice above the fold. Hide the header logo until the hero has
    // scrolled fully out of view, same pattern editorial fashion sites use.
    // Scoped by this element's presence, not a template check, so every
    // other page is untouched (the class this adds is never present there).
    var homeHero = document.querySelector('.hs-shed-hero');
    if (homeHero) headerWrapper.classList.add('header--home');

    // Nothing to watch for on non-home pages.
    if (!homeHero) return;

    // A scroll listener, not IntersectionObserver. IO would be the tidier
    // tool here, but it only reports while the page is actually being
    // rendered — in a background or non-painting tab its callback never
    // fires, which made the behaviour impossible to verify during
    // development (observer attached, zero callbacks, class never toggled).
    // Measuring the rect on scroll works in every context and is trivially
    // checkable. The rAF guard keeps the actual measurement to at most once
    // per frame, so this is not the per-event layout thrash the pattern is
    // usually criticised for.
    var ticking = false;

    function update() {
      ticking = false;
      var heroPastView = homeHero.getBoundingClientRect().bottom <= 0;
      headerWrapper.classList.toggle('header--home-logo-visible', heroPastView);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      // requestAnimationFrame does not fire while the document is hidden, so
      // in a background or non-painting tab the rAF hop would swallow every
      // update and the class would never flip — the same class of dead end
      // that ruled out IntersectionObserver above, one layer further in.
      // Falling back to a direct call there keeps the behaviour observable
      // (and testable) without costing a visible tab anything: a hidden tab
      // is not scrolling often enough for the throttle to matter.
      if (document.visibilityState === 'hidden') update();
      else window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor tears down and re-renders a section without a full page
  // load, which would leave the observer watching a detached node.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.header')) init();
  });
})();
